export const KeyCodes = { Fo: 32, lo: 9, To: 13, mh: 27 };
